module.exports = __webpack_public_path__ + "img/news.367c7f6e.svg";